<div class="card card-glossary row">
    <div class="glossary-vertical hidden-md-down" *ngIf="glossary">
        <div class="card-block">
            <div class="card-glossary-close">
                <button type="button" class="close" (click)="emitCloseGlossaryEvent()" aria-label="Close" *ngIf="!hideCloseButton"></button>
            </div>
            <div class=" card-glossary-utilities ">
                <div class="flex-container">
                    <div *ngIf="glossary" >
                        <button  class="btn" [ngClass]="showSpanish()? 'btn-playword-en':'btn-playword'"
                            (click)="readText()">
                        </button>
                    </div>
                    <div class="section-glossary" *ngIf="glossary" >
                        <div class="glossary-word-section">
                            <div class="card-glossary-word" [ngClass]="{'highlight': highlight.word}">
                                <span *ngFor="let elem of getSyllables()" 
                                    style="display: table-cell;"
                                    class="{{isSyllableStressed(elem) ? 'stressed' : 'unstressed'}}">
                                    <p style="white-space:pre;">{{getParsedSyllable(elem)}}</p>
                                 </span>
                            </div>
    
                            <h6 class="card-glossary-word"
                                [ngClass]="{'highlight': highlight.word}"
                                *ngIf="!glossary.syllables">
                                {{glossary.word}}
                            </h6>    
                        </div>
                    </div>
                </div>
                <div class="flex-container">

                <div *ngIf="showSpanish()" class="no-gutter">
                    <button (click)="playSpanish()"
                        class="btn btn-max-height btn-translate"
                        *ngIf="showSpanish()">
                    </button>
                </div>
                <div *ngIf="glossary" >
                    <p  class="card-spanish no-gutter"
                    *ngIf="viewSpanish()"
                    [ngClass]="{'highlight': highlight.spanish}">
                    {{spanish.word}}
                    </p>
                </div>
                </div>
            </div>
            
        </div>

        <div class="card-block card-definition definition-padding-aligned">
            <div  class="card-definition-text card-text"
                [ngClass]="{'highlight': highlight.definition}">
                {{glossary.definition.text}}
            </div>
        </div>

        <div [ngSwitch]="isVideoSrc(glossary.context.media)">
            <div *ngSwitchCase="false" class="card-glossary-image">
                <img class="card-img-top img-fluid card-glossary-img hide"
                 src="{{getImageSrc(glossary.fact.media)}}"
                 alt="Card image cap"
                 *ngIf="glossary.fact.media">

                 <img class="card-img-top img-fluid card-glossary-img"
                             src="{{getImageSrc(glossary.context.media)}}"
                             alt="Card image cap"
                             *ngIf="glossary.context.media">
            </div>

            <div *ngSwitchCase="true" class="card-glossary-video" [ngStyle]="getVideoStyle()">
                <video #glossyvideo width="240" height="160" id="glossyvideo" poster="img/logo-ra_130x138.png">
                    <source src="{{getVideoSrc(glossary.context.media, 'ogv')}}" type='video/ogg; codecs="theora, vorbis"'/>
                    <source src="{{getVideoSrc(glossary.context.media, 'webm')}}" type='video/webm' >
                    <source src="{{getVideoSrc(glossary.context.media, 'mp4')}}" type='video/mp4'>
                    <p>Video is not visible, most likely your browser does not support HTML5 video</p>
                </video>
            </div>
        </div>

        <div class="card-block card-context definition-padding-aligned">
            <div class="card-text card-context-text"
                 [ngClass]="{'highlight': highlight.context}"
                 [innerHTML]="boldedUsage()">
            </div>
            <div class="row" *ngIf="checkForDidYouKnow(glossary.fact.audio)">
                <a class="did-you-know-btn" (click)="readDidYouKnow(true)">Did you know?</a>
                <div class="did-you-know-tooltip" [ngClass]="{'active' : tab.didYouKnow}">
                    {{ glossary.fact.text }}
                </div>
            </div>
        </div>
    </div>

    <div class="glossary-horizontal hidden-lg-up">
        <button type="button" class="close" (click)="closeGlossary()" aria-label="Close" *ngIf="!hideCloseButton"></button>

        <div class="row card-glossary-utilities col-xs-6">
            <div class="col-xs-6" *ngIf="glossary">
                <h6 class="card-glossary-word"
                    *ngIf="glossary.syllables || glossary.word">
                    <button class="btn" [ngClass]="showSpanish()? 'btn-playword-en':'btn-playword'"
                        (click)="readText()">
                    </button>

                    <div class="card-glossary-word"
                         [ngClass]="{'highlight': highlight.word}">
                            <span *ngFor="let elem of getSyllables()"
                                style="display: table-cell;"
                                class="{{isSyllableStressed(elem) ? 'stressed' : 'unstressed'}}">
                                <p style="white-space:pre;">{{getParsedSyllable(elem)}}</p>
                            </span>
                    </div>

                    <span [ngClass]="{'highlight': highlight.word}"
                         *ngIf="!glossary.syllables" class="text-justify">
                         {{glossary.word}}
                    </span>
                </h6>
            </div>
            <div class="col-xs-6">
                <button (click)="playSpanish()"
                        class="btn btn-translate"
                        *ngIf="showSpanish()">
                </button>
             <div>
                <span  class="card-spanish text-justify"
                      *ngIf="viewSpanish()"
                      [ngClass]="{'highlight': highlight.spanish}">
                    {{spanish.word}}
                </span>
            </div>
            </div>
        </div>

        <div class="row card-glossary-tab" *ngIf="glossary">

            <div class="col-xs-6 no-gutter" *ngIf="glossary.context.media">
                <div [ngSwitch]="isVideoSrc(glossary.context.media)">
                    <div *ngSwitchCase="false">
                        <img class="card-img-top img-fluid card-glossary-img"
                             src="{{getImageSrc(glossary.context.media)}}"
                             alt="Card image cap">
                    </div>
                    <div *ngSwitchCase="true" class="card-glossary-video" [ngStyle]="getVideoStyle()">
                        <video #horizontalglossyvideo width="240" id="horizontalglossyvideo">
                            <source src="{{getVideoSrc(glossary.context.media, 'ogv')}}" type='video/ogg; codecs="theora, vorbis"'/>
                            <source src="{{getVideoSrc(glossary.context.media, 'webm')}}" type='video/webm' >
                            <source src="{{getVideoSrc(glossary.context.media, 'mp4')}}" type='video/mp4'>
                            <p>Video is not visible, most likely your browser does not support HTML5 video</p>
                        </video>
                    </div>
                </div>
            </div>

            <div *ngIf="glossary" class="no-gutter pr-1" [ngClass]="getGlossaryDefinitionColsBasedOnImage(glossary.context.media)">
                <div class="card-glossary-horizontal-text">
                    <div class="card-definition-text"
                    [ngClass]="{'highlight': highlight.definition}">
                        {{glossary.definition.text}}
                    </div>

                    <div class="card-text card-context-text"
                         [ngClass]="{'highlight': highlight.context}"
                         [innerHTML]="boldedUsage()">
                    </div>
                </div>

                <div class="did-you-know-section row">
                    <div class="did-you-know-section-body"
                        *ngIf="checkForDidYouKnow(glossary.fact.audio)">
                        <a class="did-you-know-btn" (click)="readDidYouKnow(true)">Did you know?</a>
                        <div class="did-you-know-tooltip" [ngClass]="{'active' : tab.didYouKnow, 'highlight': highlight.didYouKnow}">
                            {{ glossary.fact.text }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
